import { useState, useEffect } from "react";

function useElementSize(ref) {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!ref.current) return;

    let animationFrameId = null;

    const observerCallback = (entries) => {
      if (!Array.isArray(entries) || !entries.length) return;
      const entry = entries[0];

      // Defer state update to next frame to avoid ResizeObserver loop issues
      animationFrameId = requestAnimationFrame(() => {
        setSize({
          width: entry.contentRect.width,
          height: entry.contentRect.height,
        });
      });
    };

    const resizeObserver = new ResizeObserver(observerCallback);
    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [ref]);

  return size;
}

export default useElementSize;
